import { CSSProperties } from 'react';
import { clsx, styx } from 'modules/Utils';
import Icon from 'elements/Icon';
import Colors from 'modules/Colors';
import ButtonSymphony from 'elements/ButtonSymphony';

/**
 * Component for displaying subscription status with customizable appearance
 */
interface SubscriptionStatusIndicatorProps {
    /** Additional class names for styling */
    className?: string;
    /** Custom styles to apply to the container */
    style?: CSSProperties;
    /** Background color of the indicator */
    backgroundColor?: string;
    /** Function to call when indicator is clicked */
    handleOpenModal?: () => void;
    /** Margin to apply around the indicator */
    margin?: string;
    /** Maximum width of the indicator */
    maxWidth?: string;
    /** Whether to show stars icons on both sides */
    showStars?: boolean;
    /** Text to display in the indicator */
    text: string;
    /** Color of the text */
    textColor?: string;
    /** Width of the indicator */
    width?: string;
}

const SubscriptionStatusIndicator = ({
    className,
    style,
    backgroundColor,
    handleOpenModal,
    margin,
    maxWidth,
    showStars,
    text,
    textColor,
    width
}: SubscriptionStatusIndicatorProps) => {
    // Define a deeper gold color for better readability
    const deeperGold = '#D19400'; 
    // Define a lighter gold background
    const lighterGoldBg = 'rgba(245, 186, 35, 0.12)';
    
    return (
        <ButtonSymphony
            className={clsx("subscriptionStatusIndicatorButton", className)}
            variant="primary"
            size="small"
            width="100%"
            color={'gold'}
            onClick={handleOpenModal}
            iconLeft={showStars ? 'stars' : undefined}
            iconLeftColor={textColor || deeperGold}
            iconLeftSize={20}
            iconRight={showStars ? 'stars' : undefined}
            iconRightColor={textColor || deeperGold}
            iconRightSize={20}
            style={styx(
                {
                    maxWidth,
                    paddingLeft: 12,
                    paddingRight: 12,
                    backgroundColor: backgroundColor || lighterGoldBg,
                    color: textColor || deeperGold,
                    width: '100%',
                    justifyContent: 'center',
                    cursor: handleOpenModal ? 'pointer' : 'default',
                    margin
                },
                style
            )}
        >
            {text}
        </ButtonSymphony>
    );
};

export default SubscriptionStatusIndicator;